import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl-next';

import { Flex, Text } from '@atlaskit/primitives/compiled';
import { ColorPicker, isReadable, useBuiltInColorMap } from '@atlassian/color-picker';
import { useProductDependencies } from '@atlassian/company-hub-common';

import { CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE } from '../../../../constants';
import type { CardsActions } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';

import { messages } from './messages';

type TextColorFieldProps = {
	backgroundColor: string;
	isCompanyHub: boolean;
	textColor: string;
	updateMainFormField: CardsActions['updateMainFormField'];
};

export const TextColorField = ({
	textColor,
	backgroundColor,
	isCompanyHub,
	updateMainFormField,
}: TextColorFieldProps): React.JSX.Element => {
	const { isSSRProductInDarkMode, branding } = useProductDependencies();
	const { hideDefaultColorPalette } = branding ?? {};
	const { textColorMap, emptyColorMap } = useBuiltInColorMap(isSSRProductInDarkMode);
	const isReadableTextColor = (color: string) => isReadable(color, backgroundColor);

	const handleChange = useCallback(
		(color: string) => {
			updateMainFormField({ textColor: color });
		},
		[updateMainFormField],
	);

	return (
		<Flex justifyContent="space-between" alignItems="center">
			<Text color="color.text">
				<FormattedMessage {...messages.textColorLabel} />
			</Text>
			<ColorPicker
				analyticsSource={CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE}
				builtInColorMap={hideDefaultColorPalette ? emptyColorMap : textColorMap}
				isReadableColor={isReadableTextColor}
				onChange={handleChange}
				value={textColor}
				pickerTitle={messages.textColorLabel}
				showCustomPalette={!!isCompanyHub}
			/>
		</Flex>
	);
};
